import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Dropdown, DropdownButton, Form, InputGroup } from "react-bootstrap";
import apiClient from "../../../services/apiClient";
import CountryCodes from "../../../assets/data/CountryCodes.json";
import OTPInput from "react-otp-input";

const LoginWithPhone = () => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const [loading, setLoding] = useState(false);
  const [error, setError] = useState("");
  const [step, setStep] = useState("PHONE");
  const [selectedCountryCode, setSelectedCountryCode] = useState({
    name: "United States",
    dial_code: "+1",
    code: "US",
  });

  const onSendOtp = async (data) => {
    setError("");
    setLoding({
      status: true,
      stage: "SENDING",
    });
    console.log(data);
    try {
      const payload = {
        phone_number: data.phone_number,
        country_code: selectedCountryCode.dial_code,
      };
      const response = await apiClient.post("/login", payload);

      if (response?.status) {
        setStep("OTP");
      }
      setStep("OTP");
    } catch (err) {
      console.log("err: ", err);
      if (err?.response?.data) {
        setError(err?.response?.data?.message);
      }
    } finally {
      setLoding(false);
    }
  };

  const onSubmit = async (data) => {
    setError("");
    setLoding(true);
    console.log(data);
    try {
      const payload = {
        phone_number: data.phone_number,
        country_code: selectedCountryCode.dial_code,
      };
      const response = await apiClient.post("/login", payload);
      console.log(response);
      console.log("payload: ", payload);
    } catch (err) {
      console.log("err: ", err);
      if (err?.response?.data) {
        setError(err?.response?.data?.message);
      }
    } finally {
      setLoding(false);
    }
  };

  return (
    <>
      {step === "PHONE" && (
        <>
          {error && <Form.Text className="text-danger">{error}</Form.Text>}
          <Form onSubmit={handleSubmit(onSendOtp)} className="mt-4">
            <Form.Group controlId="formPhone" className="my-3">
              <Form.Label>Phone Number</Form.Label>
              <InputGroup className="mb-3">
                <DropdownButton
                  title={selectedCountryCode?.dial_code}
                  id="input-group-dropdown-1"
                  size="md"
                >
                  {CountryCodes?.map((code, index) => (
                    <Dropdown.Item key={index} onClick={() => setSelectedCountryCode(code)}>
                      <strong>{code.dial_code}</strong> {" " + code.name}
                    </Dropdown.Item>
                  ))}
                </DropdownButton>
                <Form.Control
                  type="number"
                  placeholder="Enter Phone Number"
                  {...register("phone_number", {
                    valueAsNumber: true,
                    required: "Number is required",
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Please enter a number",
                    },
                  })}
                />
              </InputGroup>
              {errors.phone_number && (
                <Form.Text className="text-danger">{errors.phone_number.message}</Form.Text>
              )}
            </Form.Group>

            <button
              className="btn btn-primary custom-btn-full my-3"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                "Get Code"
              )}
            </button>
          </Form>
        </>
      )}

      {step === "OTP" && (
        <>
          {error && <Form.Text className="text-danger">{error}</Form.Text>}
          <Form onSubmit={handleSubmit(onSubmit)} className="mt-4">
            <Form.Group controlId="formEmail" className="my-3">
              <Form.Label>Enter One Time password</Form.Label>
              <Controller
                name="otp"
                control={control}
                defaultValue=""
                rules={{
                  required: "OTP is required",
                  validate: (value) => value.length === 6 || "OTP must be 6 digits",
                }}
                render={({ field }) => (
                  <OTPInput
                    value={field.value}
                    onChange={field.onChange}
                    numInputs={6}
                    inputStyle={{
                      width: "3rem",
                      height: "3rem",
                      margin: "0 0.5rem",
                      fontSize: "1.5rem",
                      textAlign: "center",
                      borderRadius: "5px",
                    }}
                    renderInput={(props) => <input {...props} />}
                  />
                )}
              />
              {errors.otp && <Form.Text className="text-danger">{errors.otp.message}</Form.Text>}
            </Form.Group>

            <button
              className="btn btn-primary custom-btn-full my-3"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <div className="spinner-border spinner-border-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                "Submit"
              )}
            </button>
          </Form>
        </>
      )}
    </>
  );
};

export default LoginWithPhone;
